module.exports = __webpack_public_path__ + "static/img/city_icon12.09e69d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/city_icon12.png
// module id = JPOQ
// module chunks = 1